import classNames from 'classnames';
import { ComponentProps, useState } from 'react';

import DropDownMenu, { DropDownMenuOption } from './ShiftDetail/DropDownMenu';
import useOutsideClick from './utils';
import { FavouriteIcon } from '@tymbe/ui-icons';

type OptionsOwnProps = {
  showMenu?: boolean;
  setShowMenu?: (value: React.SetStateAction<boolean>) => void;
  menuOptions: DropDownMenuOption[];
  dropDownMenuClassName?: string;
};

type OptionsProps = OptionsOwnProps &
  Omit<ComponentProps<'div'>, keyof OptionsOwnProps>;

const Options = ({
  menuOptions,
  showMenu,
  setShowMenu,
  className = '',
  dropDownMenuClassName,
  ...rest
}: OptionsProps) => {
  const [menu, setMenu] = useState(false);
  const handleClick = () => {
    if (setShowMenu) {
      setShowMenu((prev) => !prev);
    } else {
      setMenu((prev) => !prev);
    }
  };
  const handleClose = () => {
    if (setShowMenu) {
      setShowMenu(false);
    } else {
      setMenu(false);
    }
  };
  const ref = useOutsideClick(handleClose);
  return (
    <div className={classNames('', className)} ref={ref} {...rest}>
      <button
        type="button"
        className="p-0 h-6 flex items-center"
        aria-label="more options button"
        onClick={handleClick}
      >
        <FavouriteIcon name='more_vert' className='size-5'/>
      </button>
      {(showMenu || menu) && (
        <DropDownMenu className={dropDownMenuClassName} options={menuOptions} onClick={handleClose} />
      )}
    </div>
  );
};

export default Options;
